// token update actions
const TOKEN_CHECKING = 'TOKEN_CHECKING';
const TOKEN_VALID = 'TOKEN_VALID';
const TOKEN_INVALID = 'TOKEN_INVALID';
const SET_TOKEN = 'SET_TOKEN';
const CLEAR_TOKEN = 'CLEAR_TOKEN';

// user actions
const SET_USER = 'SET_USER';
const CLEAR_USER = 'CLEAR_USER';

// SAML Auth actions
const SET_SAML_AUTH_URL_FETCHING = 'SET_SAML_AUTH_URL_FETCHING';
const SET_SAML_AUTH_URL = 'SET_SAML_AUTH_URL';
const SAML_AUTH_ERROR = 'SAML_AUTH_ERROR';
const SET_AUTHENTICATING = 'SET_AUTHENTICATING';
const SET_TOKEN_AND_USER = 'SET_TOKEN_AND_USER';
const CLEAR_TOKEN_AND_USER = 'CLEAR_TOKEN_AND_USER';

// flag when the token is saved and cleared in syncedStorage
const TOKEN_SAVED_SYNCED_STORAGE = 'TOKEN_SAVED_SYNCED_STORAGE';
const TOKEN_CLEARED_SYNCED_STORAGE = 'TOKEN_CLEARED_SYNCED_STORAGE';

// Tempory Actions For Testing
const DELETE_ME_EVENTUALLY_CHANGE_USER_ROLE = 'DELETE_ME_EVENTUALLY_CHANGE_USER_ROLE';
const DELETE_ME_EVENTUALLY_CHANGE_REMEDY_ID = 'DELETE_ME_EVENTUALLY_CHANGE_REMEDY_ID';



export {
  TOKEN_CHECKING,
  TOKEN_VALID,
  TOKEN_INVALID,
  SET_TOKEN,
  CLEAR_TOKEN,
  SET_USER,
  CLEAR_USER,
  SET_SAML_AUTH_URL_FETCHING,
  SET_SAML_AUTH_URL,
  SET_AUTHENTICATING,
  SAML_AUTH_ERROR,
  SET_TOKEN_AND_USER,
  CLEAR_TOKEN_AND_USER,
  TOKEN_SAVED_SYNCED_STORAGE,
  TOKEN_CLEARED_SYNCED_STORAGE,
  DELETE_ME_EVENTUALLY_CHANGE_USER_ROLE,
  DELETE_ME_EVENTUALLY_CHANGE_REMEDY_ID,
};

